/* eslint-disable eqeqeq */
import axios from 'axios';
import env from '../config/config';
import {
  router
} from '../main';
import {
  Message
} from 'iview';
import _ from 'lodash';

const statusMap = {
    400: '请求错误',
  // 401: '用户没有权限（令牌、用户名、密码错误）。',
  // 403: '用户得到授权，但是访问是被禁止的。',
    404: '找不到请求资源',
  // 406: '请求的格式不可得。',
  // 410: '请求的资源被永久删除，且不会再得到的。',
  // 422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器开小差了',
    502: '网关错误',
    503: '服务不可用',
    504: '网关超时'
};

const notCacheHeaders = {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
};

// 普通请求
export const httpClient = axios.create({
    baseURL: '/ws-truck',
    timeout: 300000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-By': 'eshipping',
        ...notCacheHeaders
    }
});

let msgCloseCb = () => {};
httpClient.interceptors.response.use(resp => {
    return resp;
}, error => {
    const {
    response
  } = error;
    const {
    status = null
  } = response;
    if (error.response && error.response.data && error.response.data.message === '请先登录') {
        router.push({
            name: 'index'
        });
        return Promise.reject(error);
    }

    const msg = statusMap[status];
    if (msg) {
        msgCloseCb();
        setTimeout(() => {
            msgCloseCb = Message.error(msg);
        }, 800);
        return Promise.reject(error);
    }

    return Promise.reject(error);
});

// yazuishou.com 请求
export const yzsHttp = axios.create({
    baseURL: '',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-By': 'eshipping',
        ...notCacheHeaders
    }
});
// /customer-extra-service 请求
export const customerExtraHttp = axios.create({
    baseURL: '/gw/customer-extra-service',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8;',
        ...notCacheHeaders
    }
});
customerExtraHttp.interceptors.response.use(resp => {
    return resp;
}, error => {
    let {
    response
  } = error;
    Message.error(response.data.msg);
    return Promise.reject(error);
});
// customer-server 请求
export const customerHttp = axios.create({
    baseURL: '/gw/customer-server',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8;',
        ...notCacheHeaders
    }
});
customerHttp.interceptors.response.use(resp => {
    return resp;
}, error => {
    let {
    response
  } = error;
    Message.error(response.data.msg);
    return Promise.reject(error);
});

// ias-server 请求
export const iasServerHttp = axios.create({
    baseURL: '/gw/ias-server',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8;',
        ...notCacheHeaders
    }
});
iasServerHttp.interceptors.response.use(resp => {
    return resp;
}, error => {
    let {
    response
  } = error;
    Message.error(response.data.msg);
    return Promise.reject(error);
});

// yazuishou.com 请求
export const yzsComHttp = axios.create({
    baseURL: '',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8'
    }
});

let basicsURL = '';
if (env.env == 'development') {
    basicsURL = 'https://api.fat.driverglobe.com/base-biz-data-server';
} else {
    basicsURL = 'https://api.carrierglobe.com/base-biz-data-server';
}
// 基础服务
export const basicsHttp = axios.create({
    baseURL: basicsURL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        ...notCacheHeaders
    }
});
basicsHttp.interceptors.response.use(resp => {
    return resp;
}, error => {
    let {
    response
  } = error;
    if (response.data.code === '100') {
        Message.error(response.data.msg);
        router.replace('/login');
        return;
    }
    Message.error(error.message);
    return Promise.reject(error);
});

// 舱单请求
export const shippingBillHttp = axios.create({
    baseURL: '/shippingbill',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        ...notCacheHeaders
    }
});
shippingBillHttp.interceptors.response.use(resp => {
    return resp;
}, error => {
    let {
    response
  } = error;
    if (response.data.code === '100') {
        Message.error(response.data.msg);
        router.replace('/login');
        return;
    }
    Message.error(error.message);
    return Promise.reject(error);
});

// 海运请求
// eslint-disable-next-line no-console
console.log(env);
let baseURL = '';
if (env.env == 'development') {
    baseURL = window.location.origin + '/gw';
} else {
    baseURL = 'https://www.shippingqq.com/gw';
}
export const seaTransportation = axios.create({
    baseURL: baseURL,
    // baseURL: 'https://www.shippingqq.com/gw',
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-By': 'eshipping',
        ...notCacheHeaders
    }
});

// 添加请求拦截器
seaTransportation.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
    console.log('config', config);
    // config.headers.Authorization = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NjA2NDM5MDAsInVzZXJJZCI6IjI3In0.PMxIA28JLJJDhOeS3WBwZLTea4zql149A1j7kKgURn8';
    config.headers.Authorization = window.localStorage.getItem('Bearer') || '';
    return config;
}, function (error) {
  // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
seaTransportation.interceptors.response.use(function (response) {
  // console.log('response', response)
  // 对响应数据做点什么
    return response.data;
}, function (error) {
  // 对响应错误做点什么
    return Promise.reject(error);
});

export default httpClient;

export const mockHttp = (data, delay = 1500) => {
    return new Promise((resolve, _) => {
        setTimeout(() => {
            resolve(data);
        }, delay);
    });
};

export const metaGen = () => {
    return {
        code: 'default',
        client: 'web',
        tag: 'default',
        time: Date.now()
    };
};

export const convResp = function (resp) {
    const data = _.get(resp, 'data.data.value', '{}');
    return JSON.parse(data);
};

export const getUploadHeader = () => {
    let str = window.location.protocol + '//' + window.location.host;
    return str;
};



// WEBPACK FOOTER //
// ./src/api/_http.js